import React, { useEffect, useState } from 'react';

import { CharacterSheetInterface } from "@dndModels";
import { SpeedType } from '@dndModels/Types';

import FlexBox from '@components/layout/FlexBox';
import CommonUtilities from '@utilities/common_utilities';
import SelectStringBox from '@components/input/selects/SelectStringBox';
import { FIVES_0_to_100 } from '@dndModels/Constants';

interface Props {
  char: CharacterSheetInterface;
}

const common_util = CommonUtilities.getInstance();

export default function CharacterSpeedCustomizations({
  char,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [editing_speed, setEditingSpeed] = useState<SpeedType | "">("");
  const [ping, setPing] = useState(false);

  const customizations = char.customizations;

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const renderSpeedCustomization = (speed: SpeedType) => {
    // debugger;
    let str = ``;
    if (customizations.overrides.speeds[speed]) {
      str += ` (Overridden)`;
    }
    return (
      <>
        <FlexBox className="clickable" onClick={() => setEditingSpeed(speed === editing_speed ? "" : speed) }>
          <FlexBox direction="column">
            <FlexBox className="header">
              { speed === "walk" ? "Speed" : `${common_util.capitalize_first(speed)}ing` }: Current { char.mind.speed[speed] }
            </FlexBox>
          </FlexBox>
          { (customizations.overrides.speeds[speed]) && 
            <FlexBox className="small_label gray">{ str }</FlexBox>
          }
        </FlexBox>
      </>
    );
  }

  const renderSelectedField = () => {
    if (editing_speed) {
      return (
        <FlexBox direction="column">
          <FlexBox className="header centered">Customizations for { editing_speed === "walk" ? "Speed" : `${common_util.capitalize_first(editing_speed)}ing` }</FlexBox>
          <FlexBox>
            <SelectStringBox 
              name="Override"
              value={ char.customizations.overrides.speeds[editing_speed] === undefined ? "Don't Override" : `${char.customizations.overrides.speeds[editing_speed]}` } 
              options={["Don't Override", ...FIVES_0_to_100]}
              onChange={ async (changed: string) => {
                if (changed === "Don't Override") {
                  delete char.customizations.overrides.speeds[editing_speed];
                } else {
                  char.customizations.overrides.speeds[editing_speed] = +changed;
                }
                setPing(!ping);
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          </FlexBox>
          <FlexBox>
            <SelectStringBox 
              name="Modifier"
              value={ char.customizations.modifiers.speeds[editing_speed] === undefined ? "Don't Modify" : `${char.customizations.modifiers.speeds[editing_speed]}` } 
              options={["Don't Modify", ...FIVES_0_to_100]}
              onChange={ async (changed: string) => {
                if (changed === "Don't Modify") {
                  delete char.customizations.modifiers.speeds[editing_speed];
                } else {
                  char.customizations.modifiers.speeds[editing_speed] = +changed;
                }
                setPing(!ping);
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          </FlexBox>
        </FlexBox>
      );
    }
    return null;
  }

  return (
    <FlexBox direction="row">
      <FlexBox xs_expand={0} direction="column">
        { renderSpeedCustomization("walk") }
        { renderSpeedCustomization("burrow") }
        { renderSpeedCustomization("climb") }
        { renderSpeedCustomization("fly") }
        { renderSpeedCustomization("swim") }
      </FlexBox>
      <FlexBox>
        { renderSelectedField() }
      </FlexBox>
    </FlexBox>
  );
}

